<template>
  <div :class="['project-card']" v-if="projectData" >
    <div :class="['solid',{'bg245':projectData.projectState==1||projectData.projectState==2}]"></div>
    <div class="content">
      <a class="info" @click.stop="toProjectInfo">
        <div class="img">
          <img :src="projectData.projectHeaderImage || headdefault" />
        </div>
        <div class="text">
          <div>
            <a  @click.stop="toProjectInfo"> {{projectData.projectName}}</a>
            <p> {{projectData.projectAddress}}</p>
            <p> {{formatDate(projectData.projectContractBegin)}}-{{formatDate(projectData.projectContractEnd)}}</p>
          </div>

          <div class="text-bottom">
            <div class="item" >
              <div class="icon">
                <img :src="buildicon" alt="">
              </div>
              <div>楼栋{{projectData.buildingNum}}</div>
            </div>
            <div class="item" >
              <div class="icon">
                <img :src="huxingicon" alt="">
              </div>
              <div>房型{{projectData.houseTypeNum}}</div>
            </div>
            <div class="item" >
              <div class="icon">
                <img :src="roomicon" alt="">
              </div>
              <div>房间{{projectData.houseNum}}</div>
            </div>
          </div>
        </div>
      </a>
      <div class="desc">
        <h3>项目简介</h3>
        <p v-html="projectData.projectDescription"></p >
      </div>
    </div>
    <div class="operate-buttons" >
      <a class="opreate-item item1" @click.stop="toUpdate" v-p="{api:'project/updateBaseInfo'}">
        <div class="tip">修改</div>
        <div class="square modify">
          <!--<img :src="modifyicon" alt="">-->
          <!--<div class="circle"></div>-->
        </div>
      </a>
      <a class="opreate-item item2" @click.stop="deleteProject" v-p="{api:'project/delete'}">
        <div class="tip">删除</div>
        <div class="square deleteicon" >
          <!--<img :src="deleteicon" alt="">-->
          <!--<div class="circle"></div>-->
        </div>
      </a>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import headdefault from '../../../../assets/headdefault.png'
  import buildicon from '../../../../assets/buildicon.png'
  import huxingicon from '../../../../assets/typeicon.png'
  import roomicon from '../../../../assets/roomicon.png'
  import modifyicon from '../../../../assets/icon/icon_modify copy@2x.png'
  import deleteicon from '../../../../assets/icon/icon_delete copy@2x.png'

  export default {
    name:'Card',
    props :{
      projectData:{
        type:Object,
        default:null,

      }
    },
    data () {
      return {
        headdefault:headdefault,
        buildicon:buildicon,
        huxingicon:huxingicon,
        roomicon:roomicon,
        modifyicon:modifyicon,
        deleteicon:deleteicon
      }
    },
    methods:{
      tohouse(){
        // let id=this.projectData.fid
        // this.$router.push({ name: 'house',params: {projectFid:this.projectData.fid}})

      },
      toInfo(value){
        let id=this.projectData.fid;
        let current=value;
        this.$router.push({ name: 'projectinfo',params: {id,current}})
      },
      formatDate(inputTime){
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '.' + m + '.' + d

      },
      toProjectInfo(){
        let id=this.projectData.fid;
        this.$router.push({ name: 'projectinfo',params: {id}})
      },
      toUpdate(){
        let id=this.projectData.fid;
        this.$router.push({ name: 'updateprojectinfo',params: {id}})
      },
      deleteProject(){
        this.$emit('deleteproject',this.projectData.fid,this.projectData.projectName)
      }

    }
  }
</script>

<style lang="css" scoped>
  .modify{
    background-image: url("../../../../assets/icon/icon_modify@2x.png");
    background-size: cover;
  }
  .modify:hover{
    background-image: url("../../../../assets/icon/icon_modify copy@2x.png");
  }

  .square{
    display: inline-block;
    width: 26px;
    height: 26px;
    border: 1px solid #DDDEE1;
    text-align: center;
    line-height: 26px;
    border-radius: 2px;

  }
  .deleteicon{
    background-size: cover;
    background-image: url("../../../../assets/icon/icon_delete@2x.png");
  }
  .deleteicon:hover{
    background-image: url("../../../../assets/icon/icon_delete copy@2x.png");
  }
  .tip{
    display: inline-block;
    width: 60px;
    position: absolute;
    background-color: #474E5D;
    font-size: 12px;
    line-height: 25px;
    color: white;
    top: -34px;
    right: -17px;
    visibility: hidden;
  }
  .tip::after{
    content: '';
    display: inline-block;
    border-top: 8px solid #474E5D;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    position: absolute;
    bottom: -7px;
    left: 23px;
  }
  .item1:hover .tip{
    visibility: visible;
  }
  .item2:hover .tip{
    visibility: visible;
  }
  .opreate-item{
    display: inline-block;
    /*width: 60px;*/
    text-align: center;
    position: relative;
  }
  .square .circle{
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #D8D8D8;
    vertical-align: middle;
    border: 1px solid #979797;
  }

  .operate-buttons{
    display: inline-block;
    position: absolute;
    font-size: 0;
    right: 15px;
    bottom: -15px;
    /*border: 1px solid #DDDEE1;*/
  }
  .project-card {
    width:400px;
    height: 350px;
    background: #FFFFFF;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.08);
    border-radius: 2px;
    overflow: visible;
    position: relative;

  }
  .solid {
    height: 4px;
    background: #CFA868;
  }
  .content {
    padding: 22px 10px 0;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;


  }
  .info {
    display: flex;
    padding-bottom: 25px;
    border-bottom: 2px solid rgba(225,225,225,1);
    height:160px;

  }
  .img {
    width: 47%;
    height: 125px;
    border-radius: 2px;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .text {
    flex: 1;
    position: relative;
    padding-left: 10px;
  }
  .text a {
    font-size: 12px;
    color: #495060;
    line-height: 22px;
    margin-bottom:6px;
  }
  .text p {
    font-size: 10px;
    color: #999999;
    line-height: 1.5;
  }
  .info {
    display: flex;

  }
  .text-bottom {
    width: 100%;
    position: absolute;
    display: flex;
    bottom: 0;
    color: rgba(0, 0, 0, .4);

  }
  .item {
    flex: 1;
  }
  .icon {
    width: 13px;
    height: 13px;
    /*border-radius: 50%;*/
    /*border: 1px solid #979797;*/
    overflow: hidden;

  }
  .icon > img{
    width: 13px;
  }
  .desc {
    padding-top: 14px;
    line-height: 1.5;
    padding-bottom: 20px;
  }
  .desc h3{
    font-size: 12px;
    color: #444;


  }
  .desc{
    overflow: hidden;
    height: 108px;
  }
  .desc p {
    padding-top: 6px;
    font-size: 12px;
    color: #999;

    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-inline-box;
    text-overflow: ellipsis;
    /*font-size: 14px;*/
  }
  .bg245{
    background-color: rgb(200,200,200)!important;
  }
</style>
